var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSonidoOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.811,
    height: 17.131,
    viewBox: "0 0 15.811 17.131",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #f5f5f5;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    className: "cls-1",
    d: "M13.76,129.369v5.149l-3.107-2.06-.74.74,4.873,3.237v-8.092Zm-4.1-1.139v-3.554l4.1-2.736v4.528L8.9,131.305h-2.8a8.8,8.8,0,0,1,0-6.154H8.631v4.1a1.026,1.026,0,0,0,1.026-1.026m-1.026-4.1H5.536l-.138.207c-1.158,1.738-1.158,6.054,0,7.792l.137.207H7.879l-4.1,4.1.725.726L19.592,122.07l-.727-.726-4.08,4.1v-5.418Z",
    transform: "translate(-3.781 -120.024)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_966",
    "data-name": "Group 966",
    transform: "translate(-3.781 -120.024)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_965",
    "data-name": "Group 965",
    className: "cls-2",
    transform: "translate(3.781 120.024)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_490",
    "data-name": "Rectangle 490",
    className: "cls-1",
    width: 16.555,
    height: 17.876,
    transform: "translate(-0.372 -0.372)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSonidoOff);
export default __webpack_public_path__ + "static/media/SonidoOFF.875efb4d3e86f653dd22c8c40230d9eb.svg";
export { ForwardRef as ReactComponent };